import React from 'react';
import PropTypes from 'prop-types';

import StatusIconSmall from '../Icons/StatusSmall';
import isPresent from '../Utils/Present';

const FilterCardTitle = (props) => (
  <span>
    { <StatusIconSmall enabled={isPresent(props.values)} /> } {props.title}
  </span>
);

FilterCardTitle.propTypes = {
  title: PropTypes.string.isRequired,
  values: PropTypes.oneOfType([PropTypes.array, PropTypes.bool, PropTypes.string])
};

export default FilterCardTitle;
